import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import BaseModal from 'react-responsive-modal';

/** Basic Modal component */
const Modal = props => {
    const {
        className,
        onClose,
        show,
        ...otherProps
    } = props;
    return (
        <BaseModal
            center
            classNames={{modal: cx('enterprise-modal_confirm_modal', className)}}
            onClose={onClose}
            open={show}
            {...otherProps}
        />
    );
};

Modal.displayName = 'Modal';

Modal.propTypes = {
    className: PropTypes.string,
    /** Function that closes modal when X button or off-modal overlay is clicked */
    onClose: PropTypes.func,
    /** Modal is visible when `show` is `true` */
    show: PropTypes.bool
};

export default Modal;
